import api from '@/libs/api'

export default {
  //产业园扶持政策 cms/articleList?pageNo=1&pageSize=2&type=15
  // getArticleList (data) { // http://123.57.32.196:9999/cms/articleList?pageNo=1&pageSize=2&type=4
  //   return api.get('/cms/articleList',data);
  // },

}